module.exports = __webpack_public_path__ + "img/menu-burger.3498abef.svg";